// extracted by mini-css-extract-plugin
module.exports = {"root":"SecurityGroupSelect__root--1nthF","defaultLabel":"SecurityGroupSelect__defaultLabel--2Mng0"};